export interface ExtendedWebGLContextAttributes extends WebGLContextAttributes {
	colorSpace?: PredefinedColorSpace
}

export function createWebGLContext(
	options?: ExtendedWebGLContextAttributes,
	canvas?: HTMLCanvasElement,
): WebGL2RenderingContext {
	const element = canvas || document.createElement("canvas")
	const gl = element.getContext("webgl2", {
		powerPreference: "high-performance",
		...options,
	})

	if (!gl) {
		throw new Error("WebGL is not available")
	}

	if (options?.colorSpace) {
		gl.drawingBufferColorSpace = options.colorSpace
		gl.unpackColorSpace = options.colorSpace
	}

	return gl
}
